const books = [
  {
    id: 11,
    title: "The Secrets of Harbourside Bay",
    description: "A gripping tale of love, betrayal, obsession, and the fragile line between reality and perception. In the quiet coastal town of Harbourside, Maine, Clara Adler's picture-perfect life begins to unravel when secrets multiply and trust erodes.",
    price: "$5.99",
    format: "Kindle",
    category: "Romance",
    image: "https://m.media-amazon.com/images/I/91BWLSIiBmL._SY522_.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0GPW7N4JZ",
    featuredBookOfMonth: true,
    limitedTimeOffer: true,
    rating: 5
  },
  {
    id: 1,
    title: "The Turner's Saga: One Family's Journey Through the EndTimes",
    description: "Follow one family's powerful journey of faith, survival, and hope as they navigate the challenges of the end times.",
    price: "$12.99",
    format: "Paperback",
    category: "Religious End-Times",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/ojobrcso_the%20turners_.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0FTSB3VL7",
    featured: true,
    rating: 5
  },
  {
    id: 2,
    title: "My Jesus My Journal: Write your own Epistle",
    description: "A guided journal for spiritual reflection, prayer, and writing your own personal epistle to deepen your faith journey.",
    price: "$7.99",
    format: "Paperback",
    category: "Journal",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/816qzuh6_my%20jesus.png",
    amazonUrl: "https://www.amazon.com/dp/B09KNGFG6Z",
    rating: 5
  },
  {
    title: "Escape From Tehran: A Navy Seal's experience in an Iranian Prison and his eventual escape",
    description: "A gripping true story of courage, survival, and determination as a Navy SEAL faces unimaginable challenges in an Iranian prison.",
    price: "$9.99",
    format: "Paperback",
    category: "Narrative Novel",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/s2yik65d_escape%20from%20tehran_.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0FF9PW945",
    rating: 5
  },
  {
    id: 4,
    title: "Bible Story Heroes For Kids: A Bible Story Coloring Book",
    description: "Bring Bible stories to life with this engaging coloring book featuring beloved heroes of faith, perfect for young learners.",
    price: "$7.00",
    format: "Paperback",
    category: "Coloring Book",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/mhk91clj_bible%20heroes.png",
    amazonUrl: "https://www.amazon.com/dp/B0FGDGNHLN",
    rating: 5
  },
  {
    id: 5,
    title: "Love Knows No Age: A Seniors Guide to Successful Dating",
    description: "Find companionship and navigate the dating scene with confidence in your golden years with this practical dating guide for seniors.",
    price: "$2.99",
    format: "Paperback",
    category: "Self-Help",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/ku6uzln1_love%20knows.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0D2TXHG1Y",
    rating: 5
  },
  {
    id: 6,
    title: "Achieve the Things You Want, Without the Things You Don't Want: Mindset Makeover",
    description: "Transform your life with powerful mindset strategies for personal growth and achieving your goals without unwanted baggage.",
    price: "$1.99",
    format: "Paperback",
    category: "Self-Help",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/aw3qpple_achieve.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0D2S3L392",
    rating: 5
  },
  {
    id: 7,
    title: "My Little Jot-N-Tittle pad",
    description: "A versatile notepad for quick thoughts, ideas, notes, and daily jottings to keep your life organized and creative.",
    price: "$3.60",
    format: "Paperback",
    category: "Journal",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/v3dsyp7e_my%20little%20jot.png",
    amazonUrl: "https://www.amazon.com/dp/B0BW2BX6YK",
    rating: 5
  },
  {
    id: 8,
    title: "The Camp Cookbook-Simple and Healthy Recipes for the campers on the Go!",
    description: "The ultimate cookbook for RVers, campers, and backpackers featuring simple, healthy recipes perfect for outdoor adventures.",
    price: "$5.99",
    format: "Paperback",
    category: "Cookbook",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/pngu3gfb_cookbook.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0D36F4QZG",
    rating: 5
  },
  {
    id: 9,
    title: "AI Income Generator-How Anyone Can Make Money With Artificial Intelligence",
    description: "Discover practical strategies to generate income using AI tools and technologies, even as a beginner.",
    price: "$5.99",
    format: "Paperback",
    category: "AI & Technology",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/6er4mcxt_AI%20generator.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0D3BVBMQG",
    rating: 5
  },
  {
    id: 10,
    title: "Cryptocurrency Trading 101 a Beginners Guide To Digital Assets",
    description: "Master cryptocurrency trading with this comprehensive beginner-friendly guide to digital assets and blockchain technology.",
    price: "$5.99",
    format: "Paperback",
    category: "Self-Help",
    image: "https://customer-assets.emergentagent.com/job_2092458f-7538-47b3-b081-a3a256f91712/artifacts/wkpntx4c_crypto.jpg",
    amazonUrl: "https://www.amazon.com/dp/B0CY28KMZQ",
    rating: 5
  }
];

export default books;
